// extracted by mini-css-extract-plugin
export default {"button_wrapper":"PostInteractions_button_wrapper__TPqaH"};